import { headerTypes } from "./constants/templateConstants";

const TemplateHeader = ({ header, updateHeader, file, setFile }) => {
  const handleHeaderChange = (field, value) => {
    updateHeader(field, value);
    
    // Reset file when header type changes to non-media
    if (field === "type" && !["IMAGE", "VIDEO", "DOCUMENT"].includes(value)) {
      setFile(null);
    }
  };

  return (
    <div className="cx-template-section">
      <h5 className="cx-template-section-title">
        <i className="bi bi-type-h1 me-2"></i>
        Header
      </h5>
      
      <div className="mb-3">
        <label className="form-label">Header Type</label>
        <select
          className="form-control"
          value={header.type}
          onChange={(e) => handleHeaderChange("type", e.target.value)}
        >
          {headerTypes.map((type) => (
            <option key={type.value} value={type.value}>
              {type.label}
            </option>
          ))}
        </select>
      </div>
      
      {header.type === "TEXT" && (
        <div className="mb-3">
          <label className="form-label">Header Text</label>
          <input
            type="text"
            className="form-control"
            value={header.text}
            onChange={(e) => handleHeaderChange("text", e.target.value)}
            placeholder="Header text (max 60 characters)"
            maxLength={60}
          />
          <div className="form-text">{60 - header.text.length} characters remaining</div>
        </div>
      )}
      
      {["IMAGE", "VIDEO", "DOCUMENT"].includes(header.type) && (
        <div className="mb-3">
          <label className="form-label required">
            {header.type === "IMAGE" && "Image Upload"}
            {header.type === "VIDEO" && "Video Upload"}
            {header.type === "DOCUMENT" && "Document Upload"}
          </label>
          
          <div className="cx-template-upload">
            <input
              type="file"
              className="form-control"
              onChange={(e) => {
                const selectedFile = e.target.files[0];
                setFile(selectedFile);
                if (selectedFile) {
                  handleHeaderChange("url", URL.createObjectURL(selectedFile));
                }
              }}
              accept={
                header.type === "IMAGE"
                  ? "image/*"
                  : header.type === "VIDEO"
                  ? "video/*"
                  : "application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              }
              required
            />
            
            {file && (
              <div className="cx-template-file-info mt-2 p-2 bg-light rounded">
                <i className="bi bi-file-earmark me-1"></i>
                <span>{file.name}</span>
                <span className="text-muted ms-2">
                  ({Math.round(file.size / 1024)} KB)
                </span>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger ms-2"
                  onClick={() => {
                    setFile(null);
                    handleHeaderChange("url", "");
                  }}
                >
                  <i className="bi bi-x"></i>
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default TemplateHeader;